import tippy from "tippy.js";
import { ActiveVote } from "@/appInterface/windows/ActiveVote";
import { accessMenu } from "@/appInterface/windows/accessMenu/accessMenu";
import { BottomBar } from "@/appInterface/windows/bottomBar";
import { CommentsWindow } from "@/appInterface/windows/CommentsWindow/CommentsWindow";
import { confirmationWindow } from "@/appInterface/windows/confirmationWindow/confirmationWindow";
import { CursorTrackingWindow } from "@/appInterface/windows/cursorTrackingWindow/cursorTrackingWindow";
import { ExportWindow } from "@/appInterface/windows/ExportWindow";
import { EditTextWindow } from "@/appInterface/windows/editTextWindow/editTextWindow";
import { infoWindow } from "@/appInterface/windows/infoWindow/infoWindow";
import { linkWidgetMenuWindow } from "@/appInterface/windows/linkWidgetMenuWindow/linkWidgetMenuWindow";
import { navigationSelectWindow } from "@/appInterface/windows/navigationSelectWindow/navigationSelectWindow";
import { passwordWindow } from "@/appInterface/windows/passwordWindow/passwordWindow";
import { reconnectWindow } from "@/appInterface/windows/reconnectWindow/reconnectWindow";
import { settingsWindow } from "@/appInterface/windows/settingsWindow/settingsWindow";
import { shapeLibraryWindow } from "@/appInterface/windows/shapeLibraryWindow/shapeLibraryWindow";
import { ShareWindow } from "@/appInterface/windows/shareWindow/shareWindow";
import { shortcutsWindow } from "@/appInterface/windows/shortcutsWindow/shortcutsWindow";
import { StickersWindow } from "@/appInterface/windows/stickersWindow/stickersWindow";
import { textWidgetLinkWindow } from "@/appInterface/windows/textWidgetLinkWindow/textWidgetLinkWindow";
import { UsersWindow } from "@/appInterface/windows/usersWindow/usersWindow";
import { VoteWindow } from "@/appInterface/windows/VoteWindow";
import { UpdateTariffWindow } from "./windows/UpdateTariff";

export class appInterface {
    usersWindow: UsersWindow;
    settingsWindow: settingsWindow;
    shortcutsWindow: shortcutsWindow;
    shapeLibraryWindow: shapeLibraryWindow;
    reconnectWindow: reconnectWindow;
    infoWindow: infoWindow;
    shareWindow: ShareWindow;
    accessMenu: accessMenu;
    passwordWindow: passwordWindow;
    navigationSelectWindow: navigationSelectWindow;
    confirmationWindow: confirmationWindow;
    stickersWindow: StickersWindow;
    bottomBar: BottomBar;
    linkWidgetMenuWindow: linkWidgetMenuWindow;
    textWidgetLinkWindow: textWidgetLinkWindow;
    editTextWindow: EditTextWindow;
    cursorTrackingWindow: CursorTrackingWindow;
    exportWindow: ExportWindow;
    commentsWindow: CommentsWindow;
    updateTariffWindow: UpdateTariffWindow;
    voteWindow: VoteWindow;
    activeVote: ActiveVote;

    constructor() {
        this.usersWindow = new UsersWindow();
        this.settingsWindow = new settingsWindow();
        this.shortcutsWindow = new shortcutsWindow();
        this.shapeLibraryWindow = new shapeLibraryWindow();
        this.reconnectWindow = new reconnectWindow();
        this.infoWindow = new infoWindow();
        this.shareWindow = new ShareWindow();
        this.accessMenu = new accessMenu();
        this.passwordWindow = new passwordWindow();
        this.navigationSelectWindow = new navigationSelectWindow();
        this.confirmationWindow = new confirmationWindow();
        this.stickersWindow = new StickersWindow();
        this.bottomBar = new BottomBar();
        this.linkWidgetMenuWindow = new linkWidgetMenuWindow();
        this.textWidgetLinkWindow = new textWidgetLinkWindow();
        this.editTextWindow = new EditTextWindow();
        this.cursorTrackingWindow = new CursorTrackingWindow();
        this.exportWindow = new ExportWindow();
        this.commentsWindow = new CommentsWindow();
        this.updateTariffWindow = new UpdateTariffWindow();
        this.voteWindow = new VoteWindow();
        this.activeVote = new ActiveVote();
    }

    show() {
        this.settingsWindow.prepare(0, "start");
        this.bottomBar.show();
    }

    createTooltipContent(defaultLabel = "") {
        return (reference) => {
            const label = reference.getAttribute("toolTipName") || defaultLabel;
            const hotkey = reference.getAttribute("data-hotkey") || "";

            const container = document.createElement("div");
            container.classList.add("barPanelTooltip-content");

            const labelEl = document.createElement("span");
            labelEl.classList.add("barPanelTooltip-label");
            labelEl.textContent = label;
            container.appendChild(labelEl);

            if (hotkey) {
                const hotkeyEl = document.createElement("span");
                hotkeyEl.classList.add("barPanelTooltip-hotkey");
                hotkeyEl.textContent = hotkey;
                container.appendChild(hotkeyEl);
            }

            return container;
        };
    }

    initToolTips() {
        tippy(".barPanelExport", {
            content: this.createTooltipContent("Экспорт"),
        });

        // drag
        tippy(".bottomBarItemDrag", {
            content: this.createTooltipContent("Перемещение"),
        });

        // search
        tippy(".bottomBarItemSearch", {
            content: this.createTooltipContent("Поиск"),
        });

        // zoom in, zoom out
        tippy(".bottomBarItemPlusZoom", {
            content: this.createTooltipContent("Приблизить"),
        });
        tippy(".bottomBarItemMinusZoom", {
            content: this.createTooltipContent("Отдалить"),
        });
        tippy(".bottomBarItemScale", {
            content: this.createTooltipContent("Масштаб"),
        });

        // настройки
        tippy(".barPanelSettings", {
            content: this.createTooltipContent("Меню"),
        });

        // Помощь
        tippy(".bottomBarItemHelp", {
            content: "Помощь",
        });
    }

    inputFocused = 0;
}
